__turbopack_context__.v({
  "autocomplete": "AddressFinder-module-scss-module__SuDRNq__autocomplete",
  "wrapper": "AddressFinder-module-scss-module__SuDRNq__wrapper",
});
